export default __webpack_public_path__ + "static/media/nab-logo.885a650a.png";